module.exports = __webpack_public_path__ + "img/aircon_out_power_on.5f51e957.png";